const NUMBER_ORDER_TOKEN = /\bnumber\b(\s+(?:asc|desc))?/;

/**
 * Invoice numbers restart every year (`АВ-00001/2026`), so ordering by `number` alone mixes years.
 * Expands a Gridify `orderBy` token `number[ asc|desc]` into `numberYear<dir>, number<dir>`.
 */
export const expandNumberOrderBy = (orderBy?: string) =>
  orderBy?.replace(
    NUMBER_ORDER_TOKEN,
    (_, direction = '') => `numberYear${direction}, number${direction}`,
  );
